module.exports = __webpack_public_path__ + "img/menuIcon4.9cff50e2.png";